import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const magazineFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'isExposed',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.viewable, value: 'true' },
      { label: OPTIONS_CONST.notViewable, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'priorityDisplayYn',
    label: '우선 노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.applied, value: 'true' },
      { label: OPTIONS_CONST.notApplied, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'magazineType',
    label: '매거진 유형',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.notAdvertisement, value: 'common' },
      { label: OPTIONS_CONST.advertisement, value: 'advertising' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'title',
    label: '제목',
    placeholder: '제목을 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'postedAt',
    label: '게시 시작 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['magazinePostBeginStartedAt', 'magazinePostBeginEndedAt'],
  },
  {
    key: 'awardedCreditYn',
    label: '크레딧 지급 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.awarded, value: 'true' },
      { label: OPTIONS_CONST.notAwarded, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'adminName',
    label: '등록 관리자',
    placeholder: '등록 관리자를 입력해주세요',
  },
];
